import connect from 'react-redux/es/connect/connect';
import PaymentTerminalForm from '../components/paymentform/PaymentTerminalForm';

const mapStateToProps = (state, ownProps) => ({
    cartItems: ownProps.cartItems ? ownProps.cartItems : state.cart.cartItems,
    bookerData: ownProps.booker ? ownProps.booker : state.cart.booker
});

export default connect(mapStateToProps, () => ({}))(PaymentTerminalForm);
